import { appConfig }  from '../../config';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../fetchTools';

export const login = (user_name,password) => {

  const url = `${getLocationOrigin()}/${appConfig.login.data.API}`;
  var options = {...defaultOptions};
  options['method'] = 'post';
  options['headers'] = {'content-type': 'application/json'}
  options['body'] = JSON.stringify({'mobile_no':user_name,'otp':password});
  console.log('Going to fetch');
  try {
   return fetch(url, options)
    .then(checkStatus)
    .then(parseJSON)
    .then(data => data)
    .catch(error => error);
  } catch(err) {
    console.error('Got error in login');
    console.error('err.message:', err.message);
  }
};


// WEBPACK FOOTER //
// ./src/app/services/API/login.js